// import BoxedCards from "@components/BasicComponents/Cards/BoxedCards/BoxedCards"
// import ContentAsset from "@components/BasicComponents/ContentAsset/ContentAsset"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAsset from "@components/WebsiteRevamp/ContentAsset/ContentAsset"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {createSlug} from "@helpers/createSlug"
import {
	// AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

// import styles from "./IntegrationSection.module.scss"

type Props = {
	mainData: AdvancedSideAssetModuleType
}
const IntegrationSection = (props: Props) => {
	const mainData = props.mainData?.mainContent?.[0]
	const title = mainData?.title ? mainData?.title : ""
	return (
		<section id={createSlug(title)}>
			<ContainerWrapper>
				{props.mainData.sectionTitle && (
					<>
						<Typography
							content={props.mainData.sectionTitle}
							fontWeight={300}
							variant={Variant.SectionTitle}
						/>
						<Separator />
					</>
				)}
				{mainData && (
					<>
						<ContentAsset data={mainData} withAspectRation />
						{/* <Separator size={32} /> */}
					</>
				)}
			</ContainerWrapper>
			<Separator size={128} />
		</section>
	)
}

export default IntegrationSection
